export const leadReportHeader = [
    {
      "name": "First Name",
      "field": "firstName",
      "values": "",
      "uid": "firstName"
    },
    {
      "name": "Last Name",
      "field": "lastName",
      "values": "",
      "uid": "lastName"
    },
    {
      "name": "Email Id",
      "field": "email",
      "values": "",
      "uid": "email"
    },
    {
      "name": "Company",
      "field": "company",
      "values": "",
      "uid": "company"
    },
    {
      "name": "Title",
      "field": "title",
      "values": "",
      "uid": "title"
    },
    {
      "name": "Work Phone",
      "field": "workPhone",
      "values": "",
      "uid": "workPhone"
    },
    {
      "name": "Source",
      "field": "source",
      "values": "",
      "uid": "campaignSource"
    },
    {
      "name": "Medium",
      "field": "medium",
      "values": "",
      "uid": "campaignMedium"
    },
    {
      "name": "Campaign",
      "field": "campaign",
      "values": "",
      "uid": "campaignName"
    },
    {
      "name": "Created Date",
      "field": "createdDate",
      "values": "",
      "uid": "createdDate"
    },
    {
      "name": "Last Visited",
      "field": "lastVisitedDate",
      "values": "",
      "uid": "lastVisitedDate"
    },
    {
      "name": "Views",
      "field": "views",
      "values": "",
      "uid": "views"
    },
    {
      "name": "Time Spent",
      "field": "timeSpent",
      "values": "",
      "uid": "timeSpent"
    },
    {
      "name": "Completion %",
      "field": "completion",
      "values": "",
      "uid": "completion"
    }
  ]